import { useCallback, useRef } from 'react';
import { usePostHog } from 'posthog-js/react';

import { trackRenewalStep } from '../../utils/analytics/renewalStep';
import { useRenewalStatus } from './RenewalStatusProvider';

/**
 * `track(step, outcome, errorCode)` for the renewal UI: sends `renewal_step` with the
 * member's provider from the renewal status. Stable across renders.
 *
 * @return {(step: string, outcome?: string, errorCode?: string|null) => void}
 */
const useTrackRenewalStep = () => {
  const posthog = usePostHog();
  const { status } = useRenewalStatus();
  const providerRef = useRef(null);
  providerRef.current = status?.provider ?? null;

  return useCallback((step, outcome, errorCode) => {
    trackRenewalStep(posthog, {
      step, outcome, errorCode, provider: providerRef.current,
    });
  }, [posthog]);
};

export default useTrackRenewalStep;
